export default function (state = [], action) {
    switch (action.type) {
        case "SELECT_MY_QUERIES":
            return action.payload;
            break;
        default:
            return state;
    }
}
